module.exports = __webpack_public_path__ + "img/广州市海珠区人才服务管理办公室.7c5ff2aa.png";